/* ============================================================
   FAQ.JS — Page-specific scripts for faq.html
   ============================================================ */

// ===== FAQ ACCORDION =====
function toggleFaq(btn){
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  const expanded = !isOpen;
  item.classList.toggle('open');
  btn.setAttribute('aria-expanded', expanded);
}

// ===== GSAP INIT =====

if(!motionReduced){

  // Hero entry
  const heroTl = gsap.timeline({ delay: 0.2 });
  heroTl
    .from('.faq-hero__headline', {
      y: 30, opacity: 0, duration: 0.6, ease: 'expo.out'
    })
    .from('.faq-hero__sub', {
      y: 20, opacity: 0, duration: 0.5, ease: 'expo.out'
    }, '-=0.3')
    .from('.faq-hero__rule', {
      scaleX: 0, opacity: 0, duration: 0.4, ease: 'power2.out'
    }, '-=0.2');

  // Bottom CTA scroll reveal
  gsap.from('.faq-cta__heading, .faq-cta__sub, .faq-cta__buttons', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.faq-cta', start: 'top 80%' }
  });

} else {
  gsap.set([
    '.faq-hero__headline',
    '.faq-hero__sub',
    '.faq-hero__rule',
    '.faq-cta__heading',
    '.faq-cta__sub',
    '.faq-cta__buttons'
  ].join(', '), { opacity: 1, y: 0, scaleX: 1 });
}